import React from "react";
import "./index.scss";

const FarmNameHeader = () => (
  <div data-testid="farm-name-header" className="farm-name-header">
    <span className="name">Farm Name</span>
  </div>
);

export default FarmNameHeader;
